const getLiveTradesEventName = (chain: string, address: string) => {
  return `liveTrade_${chain}_${address}`;
};

const getLiveCandlesEventName = (chain: string, pair: string) => {
  return `candles_${chain}_${pair}`;
};

const getLastTradeEventName = (chain: string, address: string) => {
  return `lastTrade_${chain}_${address}`;
};

const getLastCexPriceEventName = (exchange: string, id: number) => {
  return `lastCexPrice_${exchange}_${id}`;
};

export {
  getLiveTradesEventName,
  getLiveCandlesEventName,
  getLastTradeEventName,
  getLastCexPriceEventName,
};
